module.exports = __webpack_public_path__ + "img/measurement_info_left_hips_back.18147de3.jpg";